<template>
  <v-card>
    <v-card-title>Partners</v-card-title>
    <v-card-text class="pl-0 pr-0">
      <v-container>
        <v-row>
          <v-col cols="5" sm="4" md="2">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Affiliates uit:"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" type="month" no-title scrollable>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="7" sm="4" lg="3">
            <v-container>
              <v-row>
                <v-col
                  style="border-right: 1px solid grey"
                  cols="6"
                  class="pa-0"
                >
                  <strong>Partners</strong>
                </v-col>
                <v-col cols="6" class="pa-0 pl-3">
                  <strong>Inkomsten</strong>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  style="border-right: 1px solid grey"
                  cols="6"
                  class="pa-0"
                >
                  {{ affiliates.length }}
                </v-col>
                <v-col cols="6" class="pa-0 pl-3">
                  € {{ getLeadCumPrice() }}
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>

      <v-data-table
        :headers="headers"
        :items="affiliates"
        class="elevation-0"
        :mobile-breakpoint="0"
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 30],
        }"
        :items-per-page="10"
      >
        <template v-slot:[`item.date`]="{ item }">
          <span style="white-space: nowrap">
            {{ new Date(item.date).toLocaleString() }}
          </span>
        </template>
        <template v-slot:[`item.prijs`]="{ item }">
          <span style="white-space: nowrap">
            € {{ item.prijs }}
          </span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "SupplierAffiliates",

  data: () => ({
    affiliates: [],
    date: new Date().toISOString().substr(0, 7),
    menu: false,
    headers: [
      {
        text: "Datum",
        align: "start",
        sortable: true,
        value: "date",
      },
      {
        text: "E-mail",
        align: "start",
        sortable: true,
        value: "email",
      },
      {
        text: "Telefoonnummer",
        align: "start",
        sortable: true,
        value: "telefoonnummer",
      },
      {
        text: "Naam aanvrager & partner",
        align: "start",
        sortable: true,
        value: "naamAanvrager",
      },
      {
        text: "Trouwdatum",
        align: "start",
        sortable: true,
        value: "trouwdatum",
      },
      {
        text: "Provincie",
        align: "start",
        sortable: true,
        value: "provincie",
      },
      {
        text: "Rubriek",
        align: "start",
        sortable: true,
        value: "rubriek",
      },

      {
        text: "Prijs",
        align: "start",
        sortable: true,
        value: "prijs",
      },
    ],
  }),

  props: {
    supplier: Object,
  },

  computed: {
    ...mapGetters({
      user: "user",
    }),
  },

  watch: {
    user: async function (user) {
      if (user.id && this.supplier.id) {
        try {
          this.affiliates = await this.getLeads();
        } catch (e) {
          console.error(e);
        }
      }
    },
    date: async function (date) {
      if (date) {
        this.$refs.menu.save(date);
        this.menu = false;
        try {
          this.affiliates = await this.getLeads();
        } catch (e) {
          console.error(e);
        }
      }
    },
  },

  mounted: async function () {
    try {
      this.affiliates = await this.getLeads();
    } catch (e) {
      console.error(e);
    }
  },

  methods: {
    async getLeads() {
      try {
        let date = new Date(this.date);
        let month = new Date(date).getMonth() + 1;
        let year = new Date(date).getFullYear();
        const response = await fetch(
          `${this.$api}/v2/leverancier/${this.supplier.id}/affiliates/${month}/${year}`,
          {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
            },
            redirect: "follow",
            referrerPolicy: "no-referrer",
          }
        );

        return response.json();
      } catch (e) {
        console.error(e);
      }
    },
    getLeadCumPrice() {
      let price = 0;
      this.affiliates?.map((lead) => {
        price += lead.prijs;
        return lead;
      });
      return price;
    },
  },
});
</script>

<style>
</style>